import type { UserEventCategory } from "@/services/api/cronos/user/events/get-all"

const eventCategories: UserEventCategory[] = [
  "work",
  "study",
  "wellness",
  "recreation",
  "study_time",
]

export default eventCategories
